export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="col-span-1 md:col-span-2">
            <img
              src="https://static.readdy.ai/image/ae118e97ebc078ab009b24ac4999483c/fa7964596e535c2b9e3b8387287af291.png"
              alt="SafePoint Solutions"
              className="h-16 w-auto mb-4"
            />
            <p className="text-gray-400 text-sm leading-relaxed max-w-md">
              Securing What Matters Most. With over 20 years of state and federal law enforcement experience, we provide comprehensive security, storm preparedness, and preventative maintenance services.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('home')}
                  className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer"
                >
                  Home
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('about')}
                  className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer"
                >
                  About Us
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('services')}
                  className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('contact')}
                  className="text-gray-400 hover:text-teal-400 transition-colors text-sm cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <i className="ri-phone-line text-teal-400 text-lg mt-0.5"></i>
                <span className="text-gray-400 text-sm">786-447-6283</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-mail-line text-teal-400 text-lg mt-0.5"></i>
                <span className="text-gray-400 text-sm">Info@safepoint-solutions.com</span>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-teal-400 text-lg mt-0.5"></i>
                <span className="text-gray-400 text-sm">Serving Miami-Dade, Broward and Monroe Counties</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} SafePoint Solutions. All rights reserved.
          </p>
          <a
            href="https://readdy.ai/?ref=logo"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-400 hover:text-teal-400 transition-colors text-sm"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}